import React from 'react'
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
    BarElement,
    CategoryScale,
    LinearScale,
} from 'chart.js';

// Register the required Chart.js components
ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    Title,
    BarElement,
    CategoryScale,
    LinearScale
);
const EnergyDistributionGraph = () => {
    const data = {
        labels: ['Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri'], // Days of the week
        datasets: [
            {
                label: '1st floor',
                data: [235, 260, 590, 200, 190, 250, 220],
                backgroundColor: '#1f77b4', // Blue color
            },
            {
                label: '2nd floor',
                data: [200, 180, 160, 240, 220, 270, 260],
                backgroundColor: '#ff7f0e', // Orange color
            },
            {
                label: '3rd floor',
                data: [150, 140, 130, 180, 170, 210, 200],
                backgroundColor: '#aec7e8', // Light blue color
            },
            {
                label: 'Others',
                data: [100, 120, 140, 160, 180, 190, 150],
                backgroundColor: '#ffbb78', // Light orange color
            },
        ],
    };

    const options = {
        responsive: true,
        scales: {
            x: {
                stacked: true, // Stack bars on the x-axis
            },
            y: {
                stacked: true, // Stack bars on the y-axis
                beginAtZero: true,
                // max: 100, // Adjust based on your actual data
            },
        },
        plugins: {
            legend: {
                display: false, // Hide legend
                position: 'bottom', // Place legend at bottom (if displayed)
            },
            tooltip: {
                enabled: true, // Enable tooltips for interaction
            },
        },
    };
    return (
        <div className="p-0 py-2 px-2">
            <div className="box py-2 energyBox">
                <h6 className="p-2 my-1"><b>Energy Distribution</b></h6>
                <div className="g-cont">
                    <Bar data={data} options={options} />
                </div>
                <div className="lists p-2 mt-4">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>
                                    Breakdown
                                </th>
                                <th className="text-end">
                                    KWHs
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="legend">
                                        <div className="legend-color legend-1st">
                                        </div>
                                        1st floor
                                    </div>
                                </td>
                                <td>
                                    235
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="legend">
                                        <div className="legend-color legend-2nd">
                                        </div>
                                        2nd floor
                                    </div>
                                </td>
                                <td>
                                    408
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="legend">
                                        <div className="legend-color legend-3rd">
                                        </div>
                                        3rd floor
                                    </div>
                                </td>
                                <td>
                                    379
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="legend">
                                        <div className="legend-color legend-others">
                                        </div>
                                        Others
                                    </div>
                                </td>
                                <td>
                                    379
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    )
}
export default EnergyDistributionGraph;
